import primaryButton from '../../../../primary-button';

const primary = (params) => primaryButton.solidIcon.background.active.primary(params);

export default primary;
